// extracted by mini-css-extract-plugin
module.exports = {"modalupload":"multiplr_modalupload__2p0uH"};